﻿import {IErrorInformation} from '../../core/services/errorRedirectService/errorInformation.model';
import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";

export class ErrorViewController {
    public errorInformation: IErrorInformation;

    static $inject = ['$state', '$stateParams', 'screenLockService'];
    constructor(private $state: ng.ui.IStateService,
        params: any,
        private screenLockService: ScreenLockService) {
        if (params)
            this.errorInformation = params.errorInformation;
        this.activate();
    }

    private activate(): void {
        angular.element(document.body).removeClass('modal-open');
        angular.element('.modal-backdrop').remove();
        this.screenLockService.broadcast(0);        
    }

    public homeButtonClick(): void {
        this.$state.go('shellFrame.accountFrame.accountSummary');
    }
}
